<template>
  <!--转学须知-->
  <div class="html">
    <div class="body">
      <div id="header">
        <div class="box1">
          <div class="box2">
            <p class="Chinese">长春新区招生入学管理平台</p>
            <p class="English">
              CHANG CHUN XIN QU ZHAO SHENG RU XUE GUAN LI PING TAI
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="box3">
        <ul class="ul1">
          <li>
            <a @click="onjump()"><span>首页</span></a>
          </li>
          <li>
            <a @click="jump('distRecruitStudents')"><span>招生政策</span></a>
          </li>
          <li>
            <a @click="jump('distDegree')"><span>学位占用查询</span></a>
          </li>
          <li>
            <a href="http://www.ccxq.gov.cn/ztzl/xqcx"><span>学区查询</span></a>
          </li>
          <li id="li" @mouseleave="show = false" @mousemove="show = true">
            <span>学位预警</span>
            <ul id="ul2" :class="show == false ? '' : 'dis'">
              <a @click="jump('distWarningInfo')"><li>学位预警信息</li></a>
              <a @click="jump('waringMap')"><li>预警地图</li></a>
            </ul>
          </li>
          <li>
            <a @click="jump('distTransfer')" class="special"
              ><span>转学申请</span></a
            >
          </li>
          <li>
            <a @click="jump('distGuide')"><span>办事指南</span></a>
          </li>
        </ul>
      </div>

      <div class="notice">
        <!--箭头框-->
        <ul>
          <li class="apply1">
            <img src="../../../assets/eduDefault/9.png" class="img2" />
            <div class="odd" id="special1"></div>
          </li>
          <li class="apply2">
            <img src="../../../assets/eduDefault/9.png" class="img2" />
            <div class="even"></div>
          </li>
          <li class="apply3">
            <img src="../../../assets/eduDefault/9.png" class="img2" />
            <div class="odd"></div>
          </li>
          <li class="apply4">
            <div class="even"></div>
          </li>
        </ul>
        <p class="p">转学须知</p>
        <!--转学须知-->
        <div class="details">
          <h2>长春新区义务教育段转学须知</h2>
          <div class="innerBox" v-html="this.trends">
            <!-- <h4>一、转学条件</h4>
                    <p>学生在下列情况下可提出转学（含跨省转学）申请：</p> -->
            <!-- <p>1.因家庭居住地跨省、市、县迁移且户籍已迁入居住地的；</p>
                    <p>2.在非户籍所在地工作或者居住的人员的随迁子女，因父母（或其他法定监护人）工作或者居住地跨省、市、县发生变化的；</p>
                    <p>3.转入地学校需有空余学位。</p>
                    <h4>二、转学程序</h4>
                    <p>1.学生法定监护人在长春新区招生入学管理平台提出转学申请，对符合转学条件、确有转学需求的学生，学校进行初审后，报新区教育局审核，新区教育局依据学额空余情况，统筹安排学校接收。</p>
                    <p>2.转入学校接收后，填写《吉林省中小学生转学申请表》，转入学校在“转入学校意见”栏签字盖章。转入学校将转学材料和《转学申请表》等佐证材料清晰拍照后上传至全国中小学生学籍信息管理系统，在学籍系统内说明转学原因，通过电子学籍系统发出学籍转接申请。</p>
                    <p>3.新区教育局在电子学籍系统中核办。</p>
                    <p>4.转出学校在电子学籍系统中核办。</p>
                    <p>5.转出地学籍主管部门在电子学籍系统中核办。</p>
                    <p>6.转入学校必须获得长春新区教育局、转出学校、转出学校学籍主管部门同意后，方可通知学生报到入学。</p>
                    <p>7.待学生到转入学校报到后，转入学校通过电子学籍系统调取学生电子学籍档案。</p>
                    <p>8.转出学校将学生的纸质学籍档案寄出，并通知转入学校。</p>
                    <p>9.转入学校以收到的学籍档案为基础为学生接续档案，转出学校应保留电子档案备份，同时保留必要的纸质档案复印件。 跨省转入转出的，还须符合其他相关省份的学籍管理规定。</p>
                    <h4>三、转学相关要求</h4>
                    <p>学生转学不得变更就读年级，毕业年级学生原则上不准转学。转学一般在学期初两周内进行。同区公办学校无特殊情况原则上不予办理转学。</p>
                    <p>学籍管理实行“籍随人走、人籍相符”,严禁出现人籍分离、空挂学籍、学籍造假等现象。</p>
                    <h4>四.转学申请材料</h4>
                    <p>1.本市户籍（长春新区常住人口）提供材料：</p>
                    <p>（1）学生法定监护人身份证原件及复印件；</p>
                    <p>（2）居民户口本、房屋权属证明等材料原件及复印件。</p>
                    <p>2.非本市户籍提供材料：</p>
                    <p>（1）学生法定监护人身份证；</p>
                    <p>（2）居民户口本、有效居住证（在长春新区购房的，可同时提供房屋权属证明）等材料原件及复印件。</p>
                    <p>备注：1.转学需孩子法定监护人亲自办理。孩子和父母不在同一个户口本的，同时需要提供父母结婚证、孩子出生证明。</p>
                    <p>2.因系统目前处在调试阶段，“转学申请”暂不在“长春新区招生入学管理平台”上进行，请到长春新区教育局招生办办理，咨询电话：0431-82538556。</p> -->
          </div>
          <!-- <div class="enclosure" v-show="enclosurelist.length>0">
                    <div v-for="(item, index) of enclosurelist" :key="index"><img src="../../../assets/eduDefault/enclosure.png"/><a :href='item.filePath' download="">{{item.fielName}}</a></div>
                </div> -->
        </div>
        <a @click="jump('freedegree')"
          ><span class="button">已经阅读，进行申请</span></a
        >
      </div>
    </div>

    <!--底部-->
    <div class="interlayer"></div>
    <foot></foot>
  </div>
</template>
<script>
import {
  districts,
  action,
  infoList,
  getInfoListByOrgId,
} from "@/modules/district/api";
import { mapActions, mapState } from "./state";
import foot from "@/components/foot.vue";
export default {
  name: "degree",
  data() {
    return {
      districts: [],
      action: [],
      trends: "",
      arr: [],
      showcheckeddetailelement: false,
      show: false,
    };
  },
  components: {
    foot,
  },
  computed: {
    ...mapState(["districtName", "currentPage"]),

    name() {
      return this.$site.getName();
    },

    orgId() {
      return this.$site.getOrg();
    },
  },

  created() {
    this.loadBaseData();
  },
  methods: {
    async loadBaseData() {
      console.log(this.$site.getName());
      await districts().then((res) => {
        if (res.code == "0") {
          this.districts = res.data;
          for (let i = 0; i < this.districts.length; i++) {
            let item = this.districts[i];
            if (item.name != this.name) {
              this.arr.push(item);
            }
          }
        }
      });

      let res = await action({ orgId: this.orgId, templateId: 1 });
      this.action = res.data;
      // res = await infoList({params: 4, city: 2201, currentPage: this.currentPage})
      // this.trends = res.data.list[0].content
      res = await getInfoListByOrgId({
        params: 4,
        orgId: this.orgId,
        currentPage: this.currentPage,
      });
      this.trends = res.data.list[0].content; //lv
    },

    onjump() {
      window.location.href = "/#/";
    },

    jump(item) {
      if (item == "distSchDistrict") {
        if (this.orgId == 220104) {
          window.location.href =
            "http://www.cczhcy.com/payment/education-district";
        } else if (this.orgId == 220177) {
          window.location.href = "http://ccxq.gov.cn/xueqvchaxun.aspx";
        } else {
          this.$router.push(item);
        }
      } else {
        this.$router.push(item);
      }
    },

    transname(orgId, name) {
      this.$site.setOrg(orgId);
      this.$site.setName(name);
      //this.$router.go(0)
      this.$router.push("distDegree");
    },
    enroll() {
      alert("敬请期待...");
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.html {
  width: 100%;
  height: auto;
  min-height: 100%;
  position: relative;
  overflow-x: hidden;
  overflow: hidden;
}

.body {
  width: 100%;
  height: auto;
  position: relative;
}
#header {
  width: 100%;
  height: 239px;
  background: url("../../../assets/eduDefault/bg.png") no-repeat;
  background-size: cover;
  position: relative;
}
.box1 {
  width: 668.16px;
  height: 84.96px;
  position: absolute;
  top: 60px;
  cursor: pointer;
}
.box2 {
  width: 583.2px;
  height: auto;
  position: absolute;
  right: 0;
  top: 0;
}
.Chinese {
  font-family: PingFangSC-Semibold;
  font-size: 43.2px;
  color: #3d3d3d;
  letter-spacing: 2px;
  font-weight: bold;
}
.English {
  font-family: PingFang-SC-Semibold;
  font-size: 14px;
  color: #494949;
  letter-spacing: 2px;
  line-height: 36px;
}

.box3 {
  width: 100%;
  height: auto;
  background: #ffffff;
  box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.5);
}
.box3 .ul1 {
  width: 1148px;
  height: 54px;
  margin: 0 auto;
}

.box3 .ul1 li {
  width: 164px;
  height: 100%;
  line-height: 54px;
  float: left;
  text-align: center;
  cursor: pointer;
  font-size: 15.6px;
  font-family: PingFangSC-Regular;
  color: #000000;
  letter-spacing: -0.66px;
}
.box3 .ul1 li a {
  color: #000;
  display: block;
}
.box3 .ul1 li:hover a {
  color: #fff;
}

.box3 .ul1 li:hover {
  background: #abe000;
  color: #fff;
}

.box3 .ul1 .special {
  background: #abe000;
  color: #fff;
}
#li {
  position: relative;
}
#ul2 {
  display: none;
  position: absolute;
  z-index: 999;
}
#ul2 a li {
  background: #fff;
  box-shadow: 0 9px 10px 5px rgba(224, 224, 224, 0.5);
}
#ul2 a:hover li {
  background: #abe000;
  color: #fff;
}

.notice {
  width: 1180px;
  height: auto;
  margin: 30px auto;
  /*margin-top: 80px !important;*/
  padding-bottom: 60px;
  padding-top: 0 !important;
}

/*箭头框*/
.notice ul {
  width: 1000px;
  height: auto;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.notice ul li {
  width: 180px;
  height: 110px;
  float: left;
  position: relative;
}

.notice ul .apply1 #special1 {
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background: url("../../../assets/eduDefault/1.png") no-repeat;
  background-size: cover;
}

.notice ul .apply2 .even {
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background: url("../../../assets/eduDefault/2.png") no-repeat;
  background-size: cover;
}

.notice ul .apply3 .odd {
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background: url("../../../assets/eduDefault/5.png") no-repeat;
  background-size: cover;
}
.notice ul .apply4 .even {
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background: url("../../../assets/eduDefault/6.png") no-repeat;
  background-size: cover;
}
.notice ul li .img2 {
  position: absolute;
  bottom: 10px;
  right: -90px;
}

.notice ul li div {
  width: auto;
  height: 40px;
  position: absolute;
  right: 40px;
  top: 50%;
  margin-top: -25px;
  color: #fff;
}

.notice ul li .odd {
  right: 40px;
}

.notice ul li .even {
  right: 40px;
}

.notice .p {
  width: 100%;
  height: auto;
  margin: 0 auto;
  margin-top: 70px;
  margin-bottom: 40px;
  font-size: 22px;
  line-height: 60px;
  text-indent: 1em;
  border-bottom: 1px solid #ccc;
}

/*转学须知*/
.notice .details {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(64, 64, 64, 0.5);
}

.details h2 {
  width: 100%;
  height: auto;
  line-height: 70px;
  text-align: center;
  font-size: 29px;
  margin-bottom: 20px;
}

.details .innerBox {
  width: 98%;
  height: auto;
  margin: 0 auto;
  line-height: 40px;
  text-indent: 2em;
}

.details .innerBox p {
  font-family: 楷体;
  font-size: 18px;
}

.details .enclosure {
  width: auto;
  height: 50px;
  position: relative;
  bottom: 10px;
  left: 50px;
  margin-top: 80px;
}

.details .enclosure img {
  width: 30px;
  height: 28px;
  margin-right: 10px;
  position: relative;
  top: 8px;
}

.notice .button {
  display: block;
  width: 200px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  margin-top: 30px;
  position: relative;
  top: 30px;
  left: 50%;
  margin-left: -100px;
  background: #8dc001;
  color: #fff;
  border: none;
  cursor: pointer;
  border-radius: 10px;
}

/*底部*/
.interlayer {
  width: 100%;
  height: 10px;
  background: #abe000;
}

#footer {
  width: 100%;
  height: auto;
  background-image: linear-gradient(180deg, #2a76e6 0%, #5ab6ff 100%);
}

.link .ul4 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  line-height: 42px;
}

#footer .footer-bottom {
  width: 100%;
  height: 108.8px;
  background: #fff;
}

#footer .footer-bottom .box7 {
  color: #5f6464;
  font-size: 16px;
  position: relative;
  top: 24.4px;
  letter-spacing: 0.5px;
}

#footer .footer-bottom .box7 p {
  line-height: 30px;
  text-align: center;
}
#footer .footer-bottom .box7 p:nth-child(3) {
  margin-left: -9px;
}

#footer .footer-bottom .box7 img {
  width: 20px;
  height: 20px;
  position: relative;
  left: 0px;
  top: 3px;
  margin-right: 5px;
}

.dis {
  display: block !important;
}
.none {
  display: none !important;
}
</style>
